export default "__VITE_ASSET__pNF$sPBW__"